import { Text, StackChildren, Colors } from '@doordash/design-language'
import * as React from 'react'
import confirmActivationStrings from './strings'

const ConfirmActivationStep: React.FC = () => (
  <StackChildren>
    <Text color={Colors.SystemGrey80}>
      {confirmActivationStrings.progressionCheckConfirmActivationDescription()}
    </Text>
  </StackChildren>
)

export default ConfirmActivationStep
